<template>
    <div class="menu-page">
        <div v-if="currentUser.account.max_channels == 1">
            <v-alert class="fade" dense text type="warning">
                Funcionalidade indisponível neste plano. Por favor, faça upgrade para o plano Profissional ou superior.
                <ib-btn class="ml-2" color="warning" @click.native="$router.push('/minha-conta')">
                    Ver planos disponíveis
                </ib-btn>
            </v-alert>
        </div>

        <v-card class="mb-4 nd-border" flat>
            <v-card-title>
                Follow-ups automáticos
            </v-card-title>

            <v-card-subtitle>
                Crie mensagens automáticas em todos os atendimentos para relembrar os contatos que deixam de interagir no meio da conversa. <ib-btn small @click="showVideo = true"><v-icon size="16" class="mr-1">mdi-help-circle-outline</v-icon>Saiba mais</ib-btn>
            </v-card-subtitle>

            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-switch inset v-model="object.enabled" :label="object.enabled ? 'Follow-ups Automáticos Ligados' : 'Follow-ups Automáticos Desligados'"></v-switch>
                    </v-col>
                </v-row>

                <v-row v-if="object.enabled">
                    <v-col cols="12" lg="6" md="6" sm="12">
                        <ib-select v-model="object.types" multiple clearable chips small-chips item-text="name" item-value="id" :items="types" label="Atuar em" color="primary" outlined hide-details="auto" />
                    </v-col>
                    <v-col cols="12" lg="3" md="3" sm="12">
                        <ib-text-field type="number" label="Não enviar antes do horário (0 a 23h)" v-model="object.start_time" max="23" min="0" hide-details="auto"></ib-text-field>
                    </v-col>

                    <v-col cols="12" lg="3" md="3" sm="12">
                        <ib-text-field type="number" label="Não enviar após o horário (0 a 23h)" v-model="object.end_time" max="23" min="0" hide-details="auto"></ib-text-field>
                    </v-col>

                    <v-col cols="12">
                        <label><b>Você pode enviar até 3 mensagens de follow-up em uma mesma conversa.</b> Dica: evite ser insistente demais para não ter o número bloqueado / marcado como spam muitas vezes, pois isso pode causar banimento do chip.</label>
                    </v-col>
                </v-row>

                <div v-if="object.enabled">
                    <v-row>
                        <v-col cols="12">
                            <label style="font-size: 16px; font-weight: bold;">1ª Mensagem</label>
                            <v-switch inset v-model="object.message_1.enabled" :label="object.message_1.enabled ? 'Ligado' : 'Desligado'" hide-details="auto"></v-switch>
                        </v-col>

                        <v-col cols="12">
                            <ib-text-field label="Mensagem" placeholder="Escreva a mensagem aqui" v-model="object.message_1.text" hide-details="auto"></ib-text-field>
                        </v-col>

                        <v-col cols="12" lg="6" md="6" sm="12">
                            <ib-text-field type="number" label="Tempo" v-model="object.message_1.time" hide-details="auto"></ib-text-field>
                        </v-col>

                        <v-col cols="12" lg="6" md="6" sm="12">
                            <ib-select v-model="object.message_1.unit" mandatory chips small-chips item-text="name" item-value="id" :items="time_types" label="Unidade" color="primary" outlined hide-details="auto" />
                        </v-col>
                    </v-row>

                    <v-divider class="my-4"></v-divider>

                    <v-row>
                        <v-col cols="12">
                            <label style="font-size: 16px; font-weight: bold;">2ª Mensagem</label>
                            <v-switch inset v-model="object.message_2.enabled" :label="object.message_2.enabled ? 'Ligado' : 'Desligado'" hide-details="auto"></v-switch>
                        </v-col>

                        <v-col cols="12">
                            <ib-text-field label="Mensagem" placeholder="Escreva a mensagem aqui" v-model="object.message_2.text" hide-details="auto"></ib-text-field>
                        </v-col>

                        <v-col cols="12" lg="6" md="6" sm="12">
                            <ib-text-field type="number" label="Tempo" v-model="object.message_2.time" hide-details="auto" messages="Contado a partir do envio da 1ª mensagem de follow-up"></ib-text-field>
                        </v-col>

                        <v-col cols="12" lg="6" md="6" sm="12">
                            <ib-select v-model="object.message_2.unit" mandatory chips small-chips item-text="name" item-value="id" :items="time_types" label="Unidade" color="primary" outlined hide-details="auto" />
                        </v-col>
                    </v-row>

                    <v-divider class="my-4"></v-divider>

                    <v-row>
                        <v-col cols="12">
                            <label style="font-size: 16px; font-weight: bold;">3ª Mensagem</label>
                            <v-switch inset v-model="object.message_3.enabled" :label="object.message_3.enabled ? 'Ligado' : 'Desligado'" hide-details="auto"></v-switch>
                        </v-col>

                        <v-col cols="12">
                            <ib-text-field label="Mensagem" placeholder="Escreva a mensagem aqui" v-model="object.message_3.text" hide-details="auto"></ib-text-field>
                        </v-col>

                        <v-col cols="12" lg="6" md="6" sm="12">
                            <ib-text-field type="number" label="Tempo" v-model="object.message_3.time" hide-details="auto" messages="Contado a partir do envio da 2ª mensagem de follow-up"></ib-text-field>
                        </v-col>

                        <v-col cols="12" lg="6" md="6" sm="12">
                            <ib-select v-model="object.message_3.unit" mandatory chips small-chips item-text="name" item-value="id" :items="time_types" label="Unidade" color="primary" outlined hide-details="auto" />
                        </v-col>
                    </v-row>
                </div>

            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <ib-btn color="primary" class="mb-2" :loading="loading" @click.native="saveObject">
                    Salvar
                </ib-btn>
            </v-card-actions>
        </v-card>

        <video-dialog v-model="showVideo" videoUrl="https://www.youtube.com/embed/p6AfkGjNcOM?rel=0" />
    </div>
</template>

<script>
import Api from "@/lib/Api";
import { emitToastr } from "@/lib/Utils";
import VideoDialog from "@/components/VideoDialog.vue";

export default {
    name: "AutoFollowUpView",

    components: {
        VideoDialog
    },

    data() {
        return {
            object: {},
            showVideo: false,
            loading: false,
            types: [
                { name: 'Chatbots de IA', id: 'ai_chatbot' },
                { name: 'Chatbots de Fluxo', id: 'flow_chatbot' },
                { name: 'Atendimento humano', id: 'human' },
            ],
            time_types: [
                { name: 'Minutos', id: 'minutes' },
                { name: 'Horas', id: 'hours' }
            ]
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.currentUser;
        },
    },

    async mounted() {
        await this.$store.dispatch('loadCurrentUser');
        this.load();
    },

    methods: {

        async load() {
            this.loading = true;
            const resp = await Api.getAutoFollowUp();
            if (resp.message) this.object = resp.message;
            this.loading = false;
        },

        async saveObject() {
            this.loading = true;
            const resp = await Api.updateAutoFollowUp(this.object);
            this.loading = false;

            if (!resp.error) {
                emitToastr("success", "Configurações atualizadas com sucesso!");
            }

        }
    },
};
</script>

<style scoped></style>